// **** import modules ****
import $ from "jquery";
import app, { vuwer } from "@@assets/scripts/common";
import "@pressmedia/vuwcolony";


// **** process ****
vuwer.add("postsSection", {
	selector: "#posts_section",
	onReadyLast($self) {
		if(!$self) {
			return false;
		}
		
		const dataList = this.get("dataList");
		const count = dataList.module.items.length;
		$self.attr({
			"data-count": count
		}).on("click", ".show-more", async e => {
			e.preventDefault();
			const $showMore = $(e.currentTarget);
			await new Promise(resolve => {
				const toClose = $showMore.hasClass("to-close");
				$.fn[`slide${toClose ? "Up" : "Down"}`].call(
					dataList.$self,
					resolve
				);
			});
			$showMore.toggleClass("to-close");
		});
	}
}, function() {
	// [add child vuw]
	this
	// define [dataList]
	.add("dataList", {
		vuwType: "colony",
		selector: "#data_list_posts",
		
		// ** for TyrellModule **
		module: {
			app,
			dataKey: "posts",
/*
			// 取得条件
			getFilter: {
				// 取得項目（未指定や空の配列の場合は全て取得）
				getParams: [],
				// 除外項目
				kickParams: [],
				// 取得条件 ※SQLのWHEREに相当
				conditions: [
					{
						"targetParam": "category",
						"condition": "not",	// [gt, gte, eq, lt, lte, not, in]
						"value": "event"
					}
				]
			},
			
			// 一覧データの日付によるグループ分けのキー（年月ごとのグループ分け）※未指定の場合は"dateUpd"
			pkGroupByDate: "dateUpd",
			
			// 一覧データの日付によるグループ分けのフォーマット ※未指定の場合は"YYYY-MM"
			byDateFormat: "YYYY-MM",
*/
			
			// データ配列のフィルタ処理用コールバック（return falseでそのデータを排除）
			// itemFilter(i, item) {
			// },
			
			// 設定情報の上書き
			configOverride: {
				// NEWマークを付ける期間
				periodNew: app.now.subtract(2, "weeks"),
				// サイト内へのリンクかの判定用
				regRoot: new RegExp(`^${RegExp.escape(app.config.rootpath)}`)
			}
		},
		
		// ** for VuwColony **
		// 記事のテンプレートのセレクタ（未指定の場合は最後の子要素がテンプレートとなる）
		articleTemplate: "",
		
		// ページャーの表示・非表示
		showPager: false,
		
		/*----------------
		* 記事表示用の関数（未指定の場合はテンプレートから生成）
		* @param item [object] １記事分のデータオブジェクト
		* @param config [object] 設定オブジェクト
		* @param $artcl [$] テンプレートから生成された$オブジェクト
		* @param module [TyrellModule] データ取得用モジュール
		* @return (falseを返すと非表示)
		*/
		initArticle(item, config, $article, module) {
			// href
			$article.find("a").each((i, elm) => {
				const { rootpath } = module.app.config;
				const href = elm.getAttribute("href");
				/^\//.test(href) && (elm.href = `${rootpath.replace(/\/$/, "")}${href}`);
						
				config.regRoot.test(elm.href) && (elm.target = "_self");
			});
			
			// NEW
			if(!config.periodNew.isAfter(item.dateIssue, "day")) {
				$article.addClass("is-new");
			}
		},
		
		async onReady($self) {
			if(!$self) {
				return false;
			}
			
			// 1件目だけリストの外に移動
			this.addReplicants();
			const firstReplicant = this.getChildren().get(0);
			if(firstReplicant) {
				firstReplicant.$self.insertBefore($self);
			}
			
			await this.initList();
		}
	}, function() {
		// appから直接アクセス可能にする
		app.posts = this.module;
	});
});
